import { render, staticRenderFns } from "./Niveles.vue?vue&type=template&id=790f051c&scoped=true"
import script from "./Niveles.vue?vue&type=script&lang=js"
export * from "./Niveles.vue?vue&type=script&lang=js"
import style0 from "./Niveles.vue?vue&type=style&index=0&id=790f051c&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&id=790f051c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f051c",
  null
  
)

export default component.exports